import { render } from "./productCard-small.vue?vue&type=template&id=70db2598&scoped=true"
import script from "./productCard-small.vue?vue&type=script&lang=js"
export * from "./productCard-small.vue?vue&type=script&lang=js"

import "./productCard-small.vue?vue&type=style&index=0&id=70db2598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70db2598"]])

export default __exports__